import Vue from 'vue';
import Router from 'vue-router';
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';

import { WorkflowRoutes } from '@/router/workflow';
import { ConfigurationRoutes } from '@/router/configuration';
import { ToolsRoutes } from '@/router/tools';
import { OidcRoutes } from '@/router/oidc';
import { CommonRoutes } from '@/router/common';
import { DocumentsToStoreRoutes } from '@/router/documentsToStore';
import { EditReferencesRoutes } from '@/router/editReferences';
import { ExampleRoutes } from '@/router/examples';

import store from '@/store';
import { MStoreConstants, StickySettingsActions, StickyStoreNames, Oidc, Search } from '@/types';
import { FindDocumentsRoutes } from './documents';
import { RouteConstants } from '@/types/constants/RouteConstants';
import { Routes as CustomerRoutes } from '@/customer';
import { SearchRoutes } from './search';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'DefaultRoute',
      redirect: Search.Criteria.name
    },
    ...WorkflowRoutes,
    ...ConfigurationRoutes,
    ...ToolsRoutes,
    ...OidcRoutes,
    ...CommonRoutes,
    ...DocumentsToStoreRoutes,
    ...EditReferencesRoutes,
    ...ExampleRoutes,
    ...FindDocumentsRoutes,
    ...CustomerRoutes,
    ...SearchRoutes
  ]
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['oidcStore/oidcIsAuthenticated'];
  const isOidcCallback = to.meta?.isOidcCallback || to.meta?.isVuexOidcCallback;
  const isPublic = to.meta?.isPublic;

  if (!isAuthenticated && !isOidcCallback && !isPublic && to.fullPath) {
    localStorage.setItem(MStoreConstants.LocalStorageKeys.MStoreOidcRedirectRoute, to.fullPath);
  }
  next();
});
router.beforeEach((to, from, next) => {
  const enteringOrExitingListMaintenance =
    (to.meta?.area === RouteConstants.Areas.ListMaintenance || from.meta?.area === RouteConstants.Areas.ListMaintenance) &&
    (to.meta?.area !== RouteConstants.Areas.ListMaintenance || (from.meta?.area !== RouteConstants.Areas.ListMaintenance && from.name !== Oidc.Callback.name));

  if (enteringOrExitingListMaintenance) {
    store.dispatch(`${StickyStoreNames.ListMaintenance}/${StickySettingsActions.ResetStickyState}`);
  }
  next();
});
router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'));
router.beforeEach((to, from, next) => {
  const isApplicationDirty = store.getters['applicationDirtyStore/isApplicationDirty'];
  const isApplicationDirtyOnModal = store.getters['applicationDirtyStore/isApplicationDirtyOnModal'];
  if (isApplicationDirty || isApplicationDirtyOnModal) {
    store.dispatch('applicationDirtyStore/setApplicationDirtyRouteNavigatedTo', to);
    store.dispatch('applicationDirtyStore/setShowApplicationDirtyModal', true);
    next(false);
  } else {
    next();
  }
});
router.beforeEach((to, from, next) => {
  store.dispatch('userStore/previousRoute', {
    name: from.name,
    params: from.params
  });
  next();
});
router.afterEach((to, from) => {
  store.dispatch('applicationDirtyStore/resetApplicationDirtyState');
  const isAppIdleOnAnotherTab = localStorage.getItem(MStoreConstants.LocalStorageKeys.IsApplicationDirty);
  if (isAppIdleOnAnotherTab?.toLowerCase() === 'true') {
    store.dispatch('applicationDirtyStore/setApplicationDirtyOnAnotherTab', true);
  }
});
router.afterEach((to, _) => {
  document.title = to.meta.title ? `${to.meta.title} | ${MStoreConstants.AppName}` : MStoreConstants.AppName;
});
export default router;
